import styled from 'styled-components';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing from '../../../../helpers/spacing';

export const HeroWrapper = styled.div`
  position: relative;

  margin-bottom: ${spacing(6)};

  ${mediaQuery.tabletLandscape`
    margin-bottom: ${spacing(8)};
  `}
`;
